import { combineReducers } from '@reduxjs/toolkit';

import cartItemsSlice from '../../CartItems/Actions/reducer';
import orderDetailSlice from '../../OrderDetail/Actions/reducer';
import orderHistorySlice from '../../OrderHistories/Actions/reducer';
import paymentResultSlice from '../../PaymentResult/Actions/reducer';

export const orderReducers = combineReducers({
  cartItems: cartItemsSlice,
  orderDetail: orderDetailSlice,
  orderHistories: orderHistorySlice,
  paymnetResult: paymentResultSlice,
});
